import { render, staticRenderFns } from "./OperatorLimitEditor.vue?vue&type=template&id=0a2b6a4c&scoped=true&"
import script from "./OperatorLimitEditor.vue?vue&type=script&lang=js&"
export * from "./OperatorLimitEditor.vue?vue&type=script&lang=js&"
import style0 from "./OperatorLimitEditor.vue?vue&type=style&index=0&id=0a2b6a4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b6a4c",
  null
  
)

export default component.exports